import { number } from 'yup';

import Object from '../Object';

export default (alias) =>
  Object(
    {
      min: number(),
      max: number(),
    },
    alias
  )
    .default(null)
    .test('positive', 'Must be > 0', function (value) {
      if (!this.schema.isType(value) || value === null) {
        return true;
      }

      const { min, max } = value;
      if (Number.isInteger(min)) {
        return min >= 0;
      }
      if (Number.isInteger(max)) {
        return max >= 0;
      }
      return true;
    })
    .test('min < max', 'Min must be < max', function (value) {
      if (!this.schema.isType(value) || value === null) {
        return true;
      }

      const { min, max } = value;
      if (Number.isInteger(min) && Number.isInteger(max)) {
        return min <= max;
      }

      return true;
    })
    .stripEmpty();
